import { useMutation } from '../';
import { newInvitation } from '../mutations';

export function useNewInvitation() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish) => {
    mutate(newInvitation, variables, (mutationData) => {
      if (typeof onFinish === 'function') {
        onFinish(mutationData);
      }
    });
  };

  return { data, isLoading, run };
}
